import React, { useState, useCallback } from "react";
import Header from "../header/Header";
import DashboardLayout from "../layout";
import UpdateQuoteNumber from "./updateQuoteNumber";
import UpdateOrderNumber from "./updateOrderNumber";
import UpdateInquireNumber from "./updateInquireNumber";
import UpdateInvoiceNumber from "./updateInvoiceNumber";
import UpdateIOR from "./updateIOR";
import UpdateCurrency from "./updateCurrency";
import IORSettingsTable from "./iorSettingsTable";
import CurrencyTable from "./CurrencyTable";
import CurrencyHistory from "./currencyHistory";
import EmailSettings from "./EmailSettings";
import Search from "../../icons/Search";
import { api } from "../../config/api"; // not used yet
import TermsConditionsTable from "./TermsConditionsTable";
import TutorialManager from "./TutorialManager";

const SettingsIndex = () => {
  const [activeSection, setActiveSection] = useState("ior");
  const [iorSearchQuery, setIorSearchQuery] = useState("");
  const [unloadCountryQuery, setUnloadCountryQuery] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [activeToggle, setActiveToggle] = useState("estimation");

  const tabs = [
    { label: "Update IOR Settings", key: "ior" },
    { label: "Update Prefix", key: "prefix" },
    { label: "Update Currency", key: "currency" },
    { label: "Email", key: "email" },
    { label: "Terms & Conditions", key: "terms" },
    { label: "Tutorial Videos", key: "tutorials" },
  ];

  const handleSectionChange = (sectionKey) => {
    setActiveSection(sectionKey);

    if (sectionKey === "prefix") {
      setIorSearchQuery("");
      setUnloadCountryQuery([]);
    }

    if (sectionKey === "email") {
      setEmailModalOpen(true);
    }
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case "ior":
        return (
          <>
            <UpdateIOR
              unloadCountryQuery={unloadCountryQuery}
              setUnloadCountryQuery={setUnloadCountryQuery}
              activeToggle={activeToggle}
              setActiveToggle={setActiveToggle}
              // CHANGED: Passed iorSearchQuery to UpdateIOR to handle filtering in sub-tabs
              iorSearchQuery={iorSearchQuery}
            />
            {activeToggle === "estimation" && (
              <IORSettingsTable
                iorSearchQuery={iorSearchQuery}
                unloadCountryQuery={unloadCountryQuery}
              />
            )}
          </>
        );

      case "currency":
        return showHistory ? (
          <CurrencyHistory setShowHistory={setShowHistory} />
        ) : (
          <>
            <UpdateCurrency setShowHistory={setShowHistory} />
            <CurrencyTable />
          </>
        );

      case 'terms':
        return (
          <>
            <TermsConditionsTable />
          </>
        )

      case 'tutorials':
        return (
          <TutorialManager />
        );

      default:
        return null;
    }
  };

  return (
    <DashboardLayout>
      <div className="w-full">
        <Header title="Settings" />

        <div className="p-2 bg-cus-gray">
          <div className="flex flex-col md:flex-row items-center justify-between gap-y-4 p-3 md:p-5 bg-white rounded-md">
            {/* Tabs */}
            <div className="flex flex-wrap justify-between gap-2 py-3 px-3 border border-gray-300 rounded-xl shadow-md">
              {tabs.map(({ label, key }) => (
                <button
                  key={key}
                  onClick={() => handleSectionChange(key)}
                  className={`py-3 px-4 text-sm rounded-md text-center transition-colors duration-300 ${activeSection === key
                    ? "btnBg text-white shadow-[#6478b0] shadow-lg"
                    : ""
                    } text-xs text-black rounded-md text-center py-2 px-3 btnHover hover:text-white transition-colors duration-300 whitespace-nowrap flex-shrink-0`}
                >
                  {label}
                </button>
              ))}
            </div>

            {/* Search Bar */}
            {/* CHANGED: Logic updated to show search bar for ANY 'ior' activeSection, regardless of toggle */}
            {activeSection === "ior" && (
              <div className="w-full md:w-auto p-3 flex space-x-2 items-center border border-blue rounded-[5px]">
                <Search />
                <input
                  type="text"
                  placeholder="Search here"
                  className="w-full bg-transparent outline-none"
                  value={iorSearchQuery}
                  onChange={(e) => setIorSearchQuery(e.target.value)}
                />
              </div>
            )}
          </div>
        </div>
        <div className="p-5">
          {activeSection === "prefix" && (
            <div className="w-full bg-gray-50 py-8 px-10 rounded-[10px] mt-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <UpdateQuoteNumber />
                <UpdateOrderNumber />
                <UpdateInquireNumber />
                <UpdateInvoiceNumber />
              </div>
            </div>
          )}

          <div className="p-5">{renderActiveSection()}</div>
        </div>

        {/* Email Settings Modal */}
        <EmailSettings
          isOpen={emailModalOpen}
          onClose={() => setEmailModalOpen(false)}
        />
      </div >
    </DashboardLayout>
  );
};

export default SettingsIndex;